import { useId } from "react";

import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";
import { cn } from "~/lib/ui";

import type { ContributionAmountFieldProps } from "./types";

/**
 * Molecule: the "FSA CONTRIBUTION" underline input from the SFRA annual form
 * (`.form-group` + `.c-loyalty-form__text-input`). The label sits on its own
 * line above a transparent, bottom-bordered input. `useId` keeps the pair
 * unique when several cards share a page — the SFRA template reused one fixed
 * id, which broke label association on the live page.
 */
export function ContributionAmountField({
  label,
  value,
  onChange,
  disabled,
  className,
  "data-testid": testId,
}: ContributionAmountFieldProps) {
  const id = useId();
  return (
    <div className={cn("mb-6 flex w-full flex-col", className)}>
      <Label
        htmlFor={id}
        className="min-[768px]:text-sm px-2.5 text-xs font-medium uppercase leading-5 tracking-widest text-blue-03"
      >
        {label}
      </Label>
      <Input
        id={id}
        type="text"
        inputMode="decimal"
        autoComplete="off"
        value={value}
        disabled={disabled}
        onChange={event => onChange(event.target.value)}
        className="h-[50px] rounded-none border-0 border-b border-blue-03 bg-transparent px-2.5 pb-0 pt-5 text-sm uppercase leading-5 text-blue-03 focus-visible:bg-white"
        data-testid={testId}
      />
    </div>
  );
}
